/**
 * Converts pixel unit to rem unit
 * 1px = 0.0625rem
 */
export const scaleSize = (size) => `${size * 0.0625}rem`;
